"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const faqItems = [{
    question: "Apa yang dimaksud dengan Fakta Integritas?",
    answer: "FAKTA INTEGRITAS is a law firm built on the belief that law is not only a normative instrument, but also a moral and social tool to uphold truth and maintain substantive justice. The name represents our commitment to fact-based legal arguments combined with unwavering moral integrity."
  }, {
    question: "Bidang hukum apa saja yang ditangani?\n",
    answer: "We provide comprehensive legal services including Civil & Land Law, Criminal Law, Administrative State Law, Business & Corporate Law, Labor Law, and Preventive Legal Services. Our team has deep expertise in each area to serve your diverse legal needs."
  }, {
    question: "Bagaimana sistem kerja tim di Fakta Integritas?",
    answer: "We operate with a competency-based team system consisting of Lead Lawyers who lead legal strategy, Associate Lawyers who handle technical aspects and documentation, and Legal Researchers who conduct in-depth legal research and case analysis. This ensures every case receives comprehensive attention."
  }, {
    question: "Berapa biaya konsultasi hukum?",
    answer: "Consultation fees vary depending on the complexity of the case and services required. We offer flexible payment schemes and always provide transparent information about costs from the start. Please contact us for a detailed fee consultation."
  }, {
    question: "Apakah tersedia konsultasi online?",
    answer: "Yes, we provide online consultation services via WhatsApp, video call, or other platforms that suit your needs. Online consultations are as effective as in-person meetings and allow you to get legal advice more flexibly."
  }, {
    question: "Bagaimana proses penanganan kasus dilakukan?",
    answer: "Our case handling process begins with an initial consultation to understand your legal issues, followed by in-depth case analysis, legal strategy development, documentation preparation, and representation in court or negotiations if needed. We keep you informed at every stage."
  }, {
    question: "Apakah Fakta Integritas menangani kasus di luar kota?",
    answer: "Yes, we handle cases throughout Indonesia. Our team has experience in various regions and can travel to your location if needed. We also have a network of legal partners in several cities to ensure optimal service."
  }, {
    question: "Apa keunggulan Fakta Integritas dibanding kantor hukum lain?",
    answer: "We stand out through our fact-based and integrity-driven approach, a professional and experienced team, comprehensive and transparent services, high levels of honesty and responsibility, and effective legal solutions. We prioritize substantive justice over mere formalities."
  }, {
    question: "Bagaimana cara memulai konsultasi?",
    answer: "You can start a consultation by contacting us via WhatsApp at +62 823-1033-5547, sending an email to info@fakteintegritas.com, or filling out the contact form on our website. Our team will respond quickly and schedule a consultation that suits your schedule."
  }, {
    question: "Apakah informasi klien dijaga kerahasiaannya?",
    answer: "Absolutely. Confidentiality of client information is our top priority. We adhere to professional ethics and applicable laws to ensure all information you share is strictly protected and only used for legal purposes with your consent."
  }];
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" ref={sectionRef} className={`dark bg-background text-foreground py-20 px-4 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="font-display font-extrabold text-5xl tracking-tight !text-[hsl(35,88%,47%)]">Pertanyaan Yang Sering Diajukan</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Temukan jawaban atas pertanyaan umum tentang layanan kami</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, i) => {
          const isOpen = openIndex === i;
          return <div key={i} data-index={i} className={`bg-secondary rounded-lg border transition-all duration-300 ${isOpen ? "border-primary shadow-medium" : "border-border"}`}>
                <Button variant="ghost" onClick={() => toggleItem(i)} className="w-full flex items-start justify-between gap-4 p-6 text-left h-auto font-semibold text-lg hover:bg-transparent focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-lg" aria-expanded={isOpen}>
                  <span className="text-foreground pr-4">
                    {item.question}
                  </span>
                  <ChevronDown className={`text-muted-foreground shrink-0 size-5 transition-transform duration-250 ${isOpen ? "rotate-180" : ""}`} />
                </Button>
                <div className={`overflow-hidden transition-all duration-250 ease-in-out ${isOpen ? "max-h-96" : "max-h-0"}`}>
                  <div className="px-6 pb-6 pt-0">
                    <p className="text-base text-muted-foreground leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-12 space-y-6">
          <p className="text-lg text-muted-foreground">Masih ada pertanyaan lain?</p>
          <Link to="#contact">
            <Button className="btn-primary">HUBUNGI KAMI</Button>
          </Link>
        </div>
      </div>
    </section>;
}